import { render, staticRenderFns } from "./TeamPackages.vue?vue&type=template&id=044c1fae&scoped=true"
import script from "./TeamPackages.vue?vue&type=script&lang=js"
export * from "./TeamPackages.vue?vue&type=script&lang=js"
import style0 from "./TeamPackages.vue?vue&type=style&index=0&id=044c1fae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c1fae",
  null
  
)

export default component.exports